<template>
    <span :class="{ [className]: true }">{{ seperateWithCommas(price) }}</span>
</template>
<script>
export default {
    name: "MoneyFormatter",
    data() {
        return {};
    },
    props: {
        price: {
            type: Number,
            required: true,
            default: 0,
        },
        className: {
            type: String,
            default: "",
        },
    },
    methods: {
        seperateWithCommas(x) {
            return new Intl.NumberFormat("tr-TR", {
                style: "currency",
                currency: "TRY",
            }).format(x);
        },
    },
    mounted() {},
};
</script>
